import { useSyncExternalStore } from "react";

export const mobileMediaQuery = "(max-width: 1023px), (pointer: coarse) and (hover: none)";

function subscribeMobile(onChange: () => void) {
  const media = window.matchMedia(mobileMediaQuery);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

export function useMobileInterface() {
  return useSyncExternalStore(subscribeMobile, () => window.matchMedia(mobileMediaQuery).matches, () => false);
}

/** Only app-internal paths may be restored after authentication. */
export function safeReturnPath(value: unknown): string {
  // eslint-disable-next-line no-control-regex -- Reject characters that URL parsing can silently discard.
  if (typeof value !== "string" || !value.startsWith("/") || /[\\\s\u0000-\u001f]/.test(value)) return "/apps";
  try {
    const base = "https://cheesyapps.invalid";
    const url = new URL(value, base);
    if (url.origin !== base || ["/login", "/access-denied"].includes(url.pathname)) return "/apps";
    return url.pathname + url.search + url.hash;
  } catch { return "/apps"; }
}
